import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var CreateQuestionMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  mutation createQuestion($questionRequest: QuestionMutationRequest!) {\n    createQuestion(questionRequest: $questionRequest) {\n      question\n    }\n  }\n"])));
export default CreateQuestionMutation;